<template>
  <div class="space-y-4">
    <div v-if="title" class="text-md font-semibold text-gray-800 mb-2">{{ title }}</div>
    <div v-if="updates && updates.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-96 overflow-y-auto pr-2">
      <div 
        v-for="(update, index) in updates" 
        :key="index" 
        class="bg-white p-4 rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-200"
      >
        <div v-if="update.source === 'OWNER'" class="flex items-center mb-2">
          <v-icon small color="primary" class="mr-2">mdi-storefront</v-icon>
          <span class="text-xs font-semibold text-primary">Owner Update</span>
        </div>
        <div v-else-if="update.source === 'CUSTOMER' || update.source === 'AGGREGATOR'" class="flex items-center mb-2">
          <v-icon small color="blue-grey lighten-1" class="mr-2">mdi-account-group</v-icon>
          <span class="text-xs font-semibold text-blue-grey">Customer/Aggregator Update</span>
        </div>
        
        <p class="text-sm text-gray-700 mb-2 leading-relaxed line-clamp-3" :title="update.text || update.content || 'No content'">
          {{ update.text || update.content || 'No content available' }}
        </p>
        
        <div class="text-xs text-gray-500">
          <span v-if="update.date || update.created_at">
            Posted: {{ formatDate(update.date || update.created_at) }}
          </span>
          <span v-else-if="update.recency">
            Recency: {{ update.recency }}
          </span>
        </div>

        <div v-if="update.quality_score" class="mt-2 text-xs text-gray-500">
          Quality Score: <span class="font-medium">{{ update.quality_score.toFixed(2) }}</span>
        </div>

         <div v-if="update.url" class="mt-2">
            <a :href="update.url" target="_blank" rel="noopener noreferrer" class="text-xs text-primary hover:underline">
              View Update <v-icon x-small>mdi-open-in-new</v-icon>
            </a>
          </div>
      </div>
    </div>
    <div v-else class="text-sm text-gray-500 italic">
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdatesDisplay',
  props: {
    updates: { // Expects an array of update objects
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Updates'
    },
    emptyText: {
      type: String,
      default: 'No updates available'
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      try {
        return new Date(dateString).toLocaleDateString(undefined, options);
      } catch (e) {
        return dateString; // Return original if formatting fails
      }
    }
  }
};
</script>

<style scoped>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
/* Add scrollbar styling for .overflow-y-auto if desired */
</style> 